import { Link } from 'react-router-dom';
import { ChevronRight, ArrowLeft, Home } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showBackButton?: boolean;
  onBack?: () => void;
}

export function Breadcrumb({ items, showBackButton = true, onBack }: BreadcrumbProps) {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div className="flex items-center space-x-4 mb-6">
      {showBackButton && (
        <button
          onClick={handleBack}
          className="flex items-center justify-center px-3 py-2 bg-white border border-gray-300 text-gray-600 hover:text-primary-600 hover:border-primary-300 transition-all rounded-lg"
          aria-label="Go back"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          <span className="text-sm font-medium">Back</span>
        </button>
      )}

      <nav className="flex items-center space-x-2 text-sm">
        <div className="flex items-center text-gray-500">
          <Home className="w-4 h-4 mr-2" />
        </div>
        {items.map((item, index) => (
          <div key={index} className="flex items-center space-x-2">
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-gray-400" />
            )}
            {item.href && index < items.length - 1 ? (
              <Link
                to={item.href}
                className="text-gray-600 hover:text-primary-600 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-gray-900 font-semibold' : 'text-gray-600'}>
                {item.label}
              </span>
            )}
          </div>
        ))}
      </nav>
    </div>
  );
}
